import { LoadingComponent, NoResultsComponent } from 'components';
import Button from 'components/common/Button';
import Image from 'next/image';
import { RouteDistanceIcon, RouteTimeIcon } from 'pages/map/icons';
import React from 'react';
import { routesPath } from 'utils/constants/routePath';
import { convertUnitsOfMeasurement } from 'utils/convertUnitsOfMeasurement';
import StarRatings from 'react-star-ratings';

import {
  AddressWrapper,
  CardImg,
  CardWrapper,
  CardWrapperMain,
  RatingWrapper,
  RouteAddress,
  RouteDistance,
  RouteKm,
  RouteName,
  RouteTime,
  Wrapper,
} from './RoutesSlider.style';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import Link from 'components/common/Link';

export default function RoutesSlider({
  id,
  routes,
  units,
  isAuthenticate,
  previewImageUrl,
  averageRating,
  time,
  name,
  distance,
  paginationRef,
}: any) {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <Wrapper ref={paginationRef}>
      <CardWrapperMain>
        {routes?.length === 0 ? (
          <NoResultsComponent />
        ) : (
          <CardWrapper
            className="sliderWrapper"
            onClick={() => router.push(`${routesPath?.routeDetails}/${id}`)}
          >
            <CardImg>
              {previewImageUrl ? (
                <Image src={previewImageUrl} alt="userImage" layout="fill" />
              ) : (
                <Image
                  src="/assets/img/tireTrace.png"
                  alt="userImage"
                  layout="fill"
                />
              )}
              {averageRating > 0 && (
                <RatingWrapper>
                  <StarRatings
                    rating={averageRating || 0}
                    starRatedColor="#FF950A"
                    numberOfStars={5}
                    name="rating"
                    starDimension="13px"
                    starSpacing="1px"
                  />
                  &nbsp;{averageRating || 0}
                </RatingWrapper>
              )}
            </CardImg>
            <AddressWrapper>
              <RouteAddress>
                <RouteName>{name}</RouteName>
                <RouteKm>
                  <RouteDistance>
                    <RouteDistanceIcon />
                    <span>
                      {convertUnitsOfMeasurement(distance / 1000, false) || 0}{' '}
                      {isAuthenticate
                        ? units
                          ? t('common:km')
                          : t('common:mi')
                        : t('common:mi')}
                    </span>
                  </RouteDistance>
                  <RouteTime>
                    <RouteTimeIcon />
                    <span>
                      {Math.floor(time / 3600) || 0} {t('common:h')}{' '}
                      {Math.floor((time % 3600) / 60) || 0} {t('common:min')}
                    </span>
                  </RouteTime>
                </RouteKm>
              </RouteAddress>
              <Link path={`${routesPath?.routeDetails}/${id}`}>
                <Button variant="default" size="sm">
                  {t('landing:events:view')}
                </Button>
              </Link>
            </AddressWrapper>
          </CardWrapper>
        )}
      </CardWrapperMain>
    </Wrapper>
  );
}
